import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Grid,
  Pagination,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css"; // import first
import PageContainer from "src/components/container/PageContainer";
// components
import { IconCurrencyRupee, IconDownload } from "@tabler/icons";
import moment from "moment";
import { TailSpin } from "react-loader-spinner";
import { toast } from "react-toastify";
import { adminAxiosInstance } from "src/api/axios";
import useFileJobs from "src/hooks/useFileJobs";
import AdminFilterBox from "./AdminFilterBox";
import HeaderCardLite from "./components/HeaderCardLite";
import TransactionTable from "./components/TransactionsTable";

const AdminTransaction = () => {
  const [transation, setTransation] = useState([]);
  const [parsedTransation, setParsedTransation] = useState([]);
  const [mainTransaction, setMainTransaction] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [exporting, setExporting] = useState(false);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const [userFilter, setuserFilter] = useState("");
  const [userIdFilter, setuserIdFilter] = useState("");
  const [customerName, setcustomerName] = useState("");
  const [productFilter, setproductFilter] = useState("");
  const [leadId, setleadId] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [action, setAction] = useState("");

  const [firstDateFilter, setfirstDateFilter] = useState(moment());
  const [secondDateFilter, setsecondDateFilter] = useState(
    moment().add(-7, "day")
  );
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [paidCount, setpaidCount] = useState(0);
  const [dueCount, setdueCount] = useState(0);
  const [limit, setLimit] = useState(50);
  const [sourceFilter, setsourceFilter] = useState("all");
  const fetchUrl = `/users/transactions?user=${userFilter}&userId=${userIdFilter}&customerName=${customerName}&product=${productFilter}&transactionId=${transactionId}&leadId=${leadId}&action=${action}&referrals=${sourceFilter === 'referral'}&non_referrals=${sourceFilter === 'non-referral'}&dateStart=${secondDateFilter}&dateEnd=${firstDateFilter}&page=${page}&limit=${limit}`;

  const { createFileJob } = useFileJobs();
  const theme = useTheme();

  const fetch = (url, resetPage = false) => {
    setLoaded(false);
    adminAxiosInstance
      .get(url)
      .then((response) => {
        if ("status" in response && response.status === 200) {
          console.log(response.data);
          const { results, totalAmount, dueCount, paidCount, count } =
            response.data;
          setTransation(results.filter((i) => i.user && i.campaign));
          setMainTransaction(results.filter((i) => i.user && i.campaign));
          setCount(count);
          setdueCount(dueCount);
          setpaidCount(paidCount);
          setTotalAmount(totalAmount);
          setLoaded(true);
          if (resetPage) {
            setPage(1);
          }
        }
      })
      .catch((e) => {
        console.log(e);
        setLoaded(true);
        setTransation([]);
        setMainTransaction([]);
      });
  };
  useEffect(() => {
    fetch(fetchUrl);
  }, [page, sourceFilter]);

  const handleAsyncExport = async () => {
    if (exporting) return;
    
    setExporting(true);
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    const fileName = `transactions_${timestamp}`;
    
    try {
    
      const filters = {
        userId: userIdFilter,
        user: userFilter,
        customerName,
        product: productFilter,
        leadId,
        transactionId,
        action: action || undefined,
        referrals: sourceFilter === 'referral',
        non_referrals: sourceFilter === 'non-referral',
        dateStart: secondDateFilter,
        dateEnd: firstDateFilter,
        page,
        limit
      };
      
      const result = await createFileJob({
        fileName,
        fileType: "transaction_csv",
        filters,
      });
      
      if (result.success) {
        toast.success("CSV export started! Check File Jobs page for progress.");
      } else {
        toast.error("Failed to start export");
      }
    } catch (error) {
      console.error("Error starting export:", error);
      toast.error("Failed to start export");
    } finally {
      setExporting(false);
    }
  };

  const transformer = (transaction) => {
    let temp = [];
    console.log(transaction);
    try {
      for (let i of transaction) {
        let obj = {
          ...i,
          action:
            i?.action && typeof i?.action === "object"
              ? i.action.join(" - ")
              : "",
          currentLevel: i?.lead?.currentLevel,
          source: i?.source,
          paid: i?.lead?.paid,
          amount: i?.amount,
          lead_id: i?.lead?._id,
          lead_createdAt: i?.lead?.createdAt,
          lead_updatedAt: i?.lead?.updatedAt,
          due_payment: i?.lead?.due_payment,
          customerName: i?.lead?.parameters && i?.lead?.parameters?.name,
          customerNumber: i?.lead?.parameters && i?.lead?.parameters?.number,
          status: i?.campaign?.status,
          title: i?.campaign?.title,
          name: i?.user?.name,
          user_id: i?.user?.user_id,
          bankAccName: `${i?.user?.bankAccount?.account_name || "-"}`,
          bankAccNumber: `${i?.user?.bankAccount?.account_number || "-"}`,
          bankIFSC: `${String(i?.user?.bankAccount?.ifsc_code) || "-"}`,
          bankValid: `${String(i?.user?.bankAccount?.valid) || "-"}`,
          balance: i?.user?.wallet ? i?.user?.wallet?.totalBalance : "-",
        };
        delete obj["campaign"];
        delete obj["user"];
        delete obj["lead"];
        temp.push(obj);
      }
    } catch (e) {
      console.log(e);
    }
    return temp;
  };

  const filterInputs = [
    {
      type: "text",
      name: "User Name",
      state: userFilter,
      setState: setuserFilter,
      function: () => {
        fetch(fetchUrl, true);
      },
    },
    {
      type: "text",
      name: "User Id",
      state: userIdFilter,
      setState: setuserIdFilter,
      function: () => {
        fetch(fetchUrl, true);
      },
    },
    {
      type: "text",
      name: "Customer Name",
      state: customerName,
      setState: setcustomerName,
      function: () => {
        fetch(fetchUrl, true);
      },
    },
    {
      type: "text",
      name: "Product Name",
      state: productFilter,
      setState: setproductFilter,
      function: () => {
        fetch(fetchUrl, true);
      },
    },
    {
      type: "text",
      name: "Lead Id",
      state: leadId,
      setState: setleadId,
      function: () => {
        fetch(fetchUrl, true);
      },
    },
    {
      type: "text",
      name: "Transaction Id",
      state: transactionId,
      setState: setTransactionId,
      function: () => {
        fetch(fetchUrl, true);
      },
    },
    {
      type: "dropdown",
      name: "Action",
      state: action,
      setState: setAction,
      items: [
        {
          value: "",
          value_label: "All",
        },
        {
          value: "pending",
          value_label: "Pending",
        },
        {
          value: "paid",
          value_label: "Paid",
        },
      ],
      defaultValue: "",
      function: () => {
        fetch(fetchUrl, true);
      },
    },
    {
      type: "date",
      dateStart: firstDateFilter,
      dateEnd: secondDateFilter,
      setDateStart: setfirstDateFilter,
      setDateEnd: setsecondDateFilter,
      function: () => {
        fetch(fetchUrl, true);
      },
    },
  ];

  return (
    <PageContainer
      title="Transactions | EarnPati"
      description="this is Earnpati Transactions Page"
      sx={{ maxWidth: { xs: "100vw", lg: "70vw" } }}
    >
      <Grid container spacing={1} sx={{ padding: "0 .5rem" }}>
        <Stack
          direction={"row"}
          spacing={2}
          justifyContent={"space-between"}
          p={2}
          sx={{
            bgcolor: theme.palette.background.main,
            width: "100%",
            borderRadius: 8,
          }}
          boxShadow={10}
        >
          <HeaderCardLite header={"Total Records"} value={count || 0} />
          <HeaderCardLite header={"Paid"} value={paidCount || 0} />
          <HeaderCardLite header={"Due"} value={dueCount || 0} />
          <HeaderCardLite
            header={"Total Amount"}
            value={
              ((
                <IconCurrencyRupee
                  style={{ verticalAlign: "text-bottom", height: "20px" }}
                />
              ) &&
                totalAmount) ||
              0
            }
          />
        </Stack>
        <Grid item xs={12} my={2}>
          <AdminFilterBox
            inputs={filterInputs}
            submitFunction={() => fetch(fetchUrl)}
            sx={{ top: "70px", background: "#fff", zIndex: 10 }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              my: 1,
            }}
          >
            <Stack
              direction="row"
              justifyContent={"space-between"}
              sx={{ width: "100%" }}
            >
              <p>
                Showing data of past:{" "}
                {parseInt(
                  moment
                    .duration(firstDateFilter - secondDateFilter)
                    .asDays() || 0
                )}{" "}
                days
              </p>
              <Stack direction={"row"} alignItems={"center"}>
                <RadioGroup
                  row
                  value={sourceFilter}
                  onChange={(e) => setsourceFilter(e.target.value)}
                >
                  <FormControlLabel
                    value="all"
                    control={<Radio />}
                    label="All"
                  />
                  <FormControlLabel
                    value="non-referral"
                    control={<Radio />}
                    label="Non Referrals"
                  />
                  <FormControlLabel
                    value="referral"
                    control={<Radio />}
                    label="Referrals"
                  />
                </RadioGroup>
                <p sx={{ mt: "15px" }}>Limit:</p>
                <TextField
                  sx={{ width: "25%", margin: "5px" }}
                  type="number"
                  placeholder={`Limit`}
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={exporting ? <TailSpin height={16} width={16} /> : <IconDownload />}
                  onClick={handleAsyncExport}
                  disabled={exporting}
                  sx={{ ml: 1 }}
                >
                  {exporting ? "Exporting..." : "Export CSV"}
                </Button>
              </Stack>
            </Stack>
          </Box>

          <Divider sx={{ my: 1 }} />
          <Box>
            {loaded ? (
              (transation?.length && (
                <TransactionTable details={transation} />
              )) || (
                <Stack
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{ width: "75vw", height: "30vh" }}
                >
                  <Typography variant="h4" sx={{ textAlign: "center" }}>
                    No Data Found
                  </Typography>
                </Stack>
              )
            ) : (
              <Stack
                justifyContent={"center"}
                alignItems={"center"}
                sx={{ width: "75vw", height: "55vh" }}
              >
                <TailSpin
                  height={45}
                  width={45}
                  style={{ margin: "auto", bg: "#444" }}
                />
              </Stack>
            )}
          </Box>
          <Stack
            direction="row"
            alignItems={"center"}
            justifyContent={"center"}
            sx={{
              position: "fixed",
              bottom: 0,
              right: 0,
              p: 2,
              background: theme.palette.success.light,
              color: theme.palette.earnpati.main,
              width: "80%",
            }}
          >
            <Pagination
              count={Math.round(count / limit) || 1}
              onChange={(e, value) => setPage(value)}
            ></Pagination>
          </Stack>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default AdminTransaction;
